import { useQuery } from '@tanstack/react-query';
import { zoneApi } from '../../services/api';

export const zoneKeys = {
  all: ['zones'] as const,
  list: (orgId?: string, siteId?: string) => ['zones', 'list', orgId, siteId] as const,
};

export function useZones(orgId?: string, siteId?: string) {
  return useQuery({
    queryKey: zoneKeys.list(orgId, siteId),
    queryFn: () => zoneApi.getZones(orgId!, siteId),
    enabled: !!orgId,
    staleTime: 60_000,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}
